/****************************************************************************
 * COPYRIGHT (c) 2025 Harman Connected Services
 *
 * All rights reserved
 *
 * This software embodies materials and concepts which are
 * confidential to Ignite Product and is made available solely
 * pursuant to the terms of a written license agreement with
 * Ignite Product.
 *
 * Designed and Developed by Harman International Industries, Inc.
 ***************************************************************************/

import React from "react";
import { useSelector } from "react-redux";
import "./AppDependencyReadOnly.css";

function AppDependencyReadOnly() {
  const submissionData = useSelector(
    (state) => state.submissionDetails.submissionDetails,
  );

  const dependencies = submissionData?.appDependencyInfo || [];

  if (dependencies.length === 0) {
    return null;
  }

  return (
    <div className="app-dependency-readonly">
      <div className="app-dependency-readonly-title">App Dependency</div>
      <div className="app-dependency-readonly-subtitle">
        External or companion applications and the respective versions required
        for this app to function properly.
      </div>

      <div className="app-dependency-readonly-table-container">
        <table className="app-dependency-readonly-table">
          <thead>
            <tr>
              <th>Package</th>
              <th>App Version</th>
            </tr>
          </thead>
          <tbody>
            {dependencies.map((dep) => (
              <tr key={`${dep.packageId}-${dep.versionCode}`}>
                <td className="ro-text-cell ro-package-cell">
                  <span className="ro-cell-text" title={dep.packageId}>
                    {dep.packageId}
                  </span>
                </td>
                <td className="ro-text-cell ro-version-cell">
                  <span
                    className="ro-cell-text"
                    title={String(dep.versionCode)}
                  >
                    {dep.versionCode}
                  </span>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}

export default AppDependencyReadOnly;
